import { createSelector } from "reselect";
// import { Scope } from "./PropTypes";

const getAllBusinessesFromState = ({ businesses }: any): any[] => businesses?.saved;
export const getAllBusinesses = createSelector(getAllBusinessesFromState, (getAllBusinessesFromState) => getAllBusinessesFromState);

const getAllBusinessesMetaFromState = ({ businesses }: any): any[] => businesses?.meta;
export const getAllBusinessesMeta = createSelector(getAllBusinessesMetaFromState, (getAllBusinessesMetaFromState) => getAllBusinessesMetaFromState);

const getBusinessValuesByIdFromState = ({ businesses }: any, candidateId: any): any => {
    const candidateKeys = Object.keys(businesses?.unsaved);

    let saved = businesses?.saved[candidateId];
    if (candidateKeys.length == 0) return {...saved};

    let newValues: any = [];

    for (let key of Object.keys(businesses?.unsaved[candidateId])) {
        let item = businesses?.unsaved[candidateId][key];

        if (item.id) continue; 

        newValues.push({
            id: item.id,
            field_id: key,
            entity_id: candidateId,
            value: item.value
        });
    }

    let adjustedValues = saved?.values.map((value: any) => {
        if (!businesses?.unsaved[candidateId]) return value;
        if (!businesses?.unsaved[candidateId][value.field_id]) return value;

        return {
            ...value,
            value: businesses.unsaved[candidateId][value.field_id]['value']
        }
    });

    return {
        ...saved,
        values: [...newValues, ...adjustedValues]
    };
};
export const getBusinessValuesById = createSelector(getBusinessValuesByIdFromState, (getBusinessValuesByIdFromState) => getBusinessValuesByIdFromState);

const getBusinessUnsavedChangesByIdFromState = ({ businesses }: any, candidateId: any): any[] => businesses?.unsaved[candidateId];
export const getBusinessUnsavedChangesById = createSelector(getBusinessUnsavedChangesByIdFromState, (getBusinessUnsavedChangesByIdFromState) => getBusinessUnsavedChangesByIdFromState);


const getBusinessEntityByIdFromState = ({ businesses }: any, candidateId: any): any[] => businesses?.saved[candidateId]?.entity[0];
export const getBusinessEntityById = createSelector(getBusinessEntityByIdFromState, (getBusinessEntityByIdFromState) => getBusinessEntityByIdFromState);

const getAllBusinessStatussesByIdFromState = ({ businesses }: any, candidateId: any): any[] => businesses?.saved[candidateId]?.status;
export const getAllBusinessStatussesById = createSelector(getAllBusinessStatussesByIdFromState, (getAllBusinessStatussesByIdFromState) => getAllBusinessStatussesByIdFromState);

const getBusinessDatasetFromState = ({ businesses }: any): any[] => businesses?.dataset;
export const getBusinessDataset = createSelector(getBusinessDatasetFromState, (getBusinessDatasetFromState) => getBusinessDatasetFromState);

const getNewBusinessIdFromState = ({ businesses }: any): any[] => businesses?.new;
export const getNewBusinessId = createSelector(getNewBusinessIdFromState, (getNewBusinessIdFromState) => getNewBusinessIdFromState);